import { CSSProperties } from "react";

export function rowItemClass(row: any, extraClass: string = ''): string {
    const depthClass = row.depth === 0 ? 'item_0' : 'item_depth';
    return `${row.canExpand ? 'table-header' : 'table-row'} table-item ${depthClass}${extraClass ? ` ${extraClass}` : ''}`;
}

export function rowDepthStyle(row: any): CSSProperties {
    return { '--depth': row.depth } as CSSProperties;
}
